/**
* 分页组件
*/
<template>
  <el-pagination v-if="total>0" class="page-box" @size-change="handleSizeChange"
                 @current-change="handleCurrentChange"
                 background
                 layout="total,  prev, pager, next, jumper"
                 :current-page.sync="currentPage"
                 :page-size="limit"
                 :total="total"
  >
  </el-pagination>
</template>
<script>
export default {
  name: 'Pagination',
  props: {
    // 避免直接改变prop属性
    // 'currentPage': {
    //   required: false,
    //   default: 1
    // },
    'total': {
      required: false,
      default: 0
    },
    'limit': {
      required: false,
      default: 10
    },
    'small': {
      required: false,
      type: Boolean,
      default: false
    }
  },
  watch: {
    currentPage(val) {
      // 改变这个值并不会触发 handleCurrentChange
      if (typeof val === "number") {
        // console.log('prop currentPage!!!');
        this.currentPage = val;
      }
    },
  },
  data() {
    return {
      currentPage: 1
    }
  },
  created() {},
  methods: {

    handleSizeChange(val) {
      /**
       * 子传父
       * 参数1 父元素方法
       * 参数2 数据
       */
      this.currentPage = 1;
      this.$emit('handleSizeChange', val)
    },
    handleCurrentChange(val) {
      /**
       * 子传父
       * 参数1 父元素方法
       * 参数2 数据
       */
      this.$emit('handleCurrentChange', val)
    }
  },
  mounted() {
    document.getElementsByClassName("el-pagination__jump")[0].childNodes[0].nodeValue = "跳转到";
  },
}
</script>

<style>
.page-box {
  margin: 24px auto;
  text-align: center;

}
.el-pagination.is-background .el-pager li:not(.disabled).active{
  background-color: #347ae2;
}
.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
  color: #7c8db5;
  border-radius: 2px;
  border: solid 1px #e6effb;
  background-color: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue